import { SHARE_OPTIONS } from '../constants'
import { trackShareExternallyClicked } from '../events'
import { ShareContextData } from '../provider/ShareContext'
import getMessageDialogUrl from './getMessageDialogUrl'

// If we productize the experiment, we should move this to @mc/share/lib
const openMessageDialog = ({
  link,
  body = link,
  shareData = {},
}: {
  link: string
  body?: string
  shareData?: Partial<ShareContextData>
}) => {
  const emailDialogUrl = getMessageDialogUrl(body)

  trackShareExternallyClicked({
    channel: SHARE_OPTIONS.MESSAGE,
    link,
    shareData,
  })

  window.open(emailDialogUrl)
}

export default openMessageDialog
